import { type FooterSection } from '@/features/shared/components/Footers/types'
import { cmsRoutes } from '@shared/constants/routes'

// --- Member Half ---
// ultimately, these link titles are going to live in CMS. - https://shipt.clickup.com/t/86b9j4dff

const shopProductsSection: FooterSection = {
  title: 'Shop Products',
  links: [
    {
      name: 'Alcohol',
      url: '/categories/alcohol',
    },
    {
      name: 'Beverages',
      url: '/categories/beverages',
    },
    {
      name: 'Home Goods',
      url: '/categories/home-goods',
    },
    {
      name: 'Produce',
      url: '/categories/produce',
    },
    {
      name: 'Meat & Seafood',
      url: '/categories/meat-and-seafood',
    },
    {
      name: 'View All',
      url: '/categories',
      showUnderline: true,
    },
  ],
}

const shopCategoriesSection: FooterSection = {
  title: 'Shop Categories',
  links: [
    {
      name: 'Grocery Delivery',
      url: '/delivery/grocery-delivery',
    },
    {
      name: 'Alcohol Delivery',
      url: '/delivery/alcohol-delivery',
    },
    {
      name: 'Pet Supplies Delivery',
      url: '/delivery/pet-supplies-delivery',
    },
    {
      name: 'Electronics Delivery',
      url: '/delivery/electronics-delivery',
    },
    {
      name: 'Household Essentials Delivery',
      url: '/delivery/household-essentials-delivery',
    },
    {
      name: 'View All',
      url: '/delivery',
      showUnderline: true,
    },
  ],
}

const joinShiptSection: FooterSection = {
  title: 'Join Shipt',
  links: [
    {
      name: 'How Shipt Works',
      url: 'https://help.shipt.com/how-shipt-works',
      external: true,
    },
    {
      name: 'Stores',
      url: '/stores',
    },
    {
      name: 'Membership',
      url: '/pricing',
    },
    {
      name: 'Gift Cards',
      url: '/gift',
    },
    {
      name: 'Shipt vs Instacart',
      url: '/lp/shipt-vs-instacart',
    },
    {
      name: 'Deals',
      url: '/shop/stores/landing-page/category/global-deals',
    },
    {
      name: 'Shipt Business',
      url: cmsRoutes.SHIPT_BUSINESS,
    },
  ],
}

const discoverShiptSection: FooterSection = {
  title: 'Discover Shipt',
  links: [
    {
      name: 'About Us',
      url: 'https://corporate.shipt.com/about',
      external: true,
    },
    {
      name: 'Careers',
      url: '/corporate/careers',
    },
    {
      name: 'Newsroom',
      url: 'https://corporate.shipt.com/news',
      external: true,
    },
    {
      name: 'Blog',
      url: '/blog',
    },
    {
      name: 'Partners',
      url: 'https://partner.shipt.com/join',
      external: true,
    },
    {
      name: 'Sitemap',
      url: '/sitemap-index',
    },
  ],
}

export const memberSections: FooterSection[] = [
  shopProductsSection,
  shopCategoriesSection,
  joinShiptSection,
  discoverShiptSection,
]

// --- Shopper Half ---

const shopAndEarnSection: FooterSection = {
  title: 'Shop & Earn',
  links: [
    {
      name: 'Be a shopper',
      url: '/shopper/be-a-shopper',
    },
    {
      name: 'Be a driver',
      url: '/driver/be-a-driver',
    },
    {
      name: 'Be an affiliate',
      url: '/partner/affiliate',
    },
    {
      name: 'Perks',
      url: '/shopper/shopper-perks',
    },
    {
      name: 'Safety',
      url: '/shopper/shopper-safety',
    },
    {
      name: 'Shopper FAQs',
      url: '/shopper/shopper-faq',
    },
  ],
}

const shopCitiesSection: FooterSection = {
  title: 'Shop Cities',
  links: [
    {
      name: 'Austin',
      url: '/cities/austin-grocery-delivery',
    },
    {
      name: 'San Francisco',
      url: '/cities/san-francisco-grocery-delivery',
    },
    {
      name: 'Miami',
      url: '/cities/miami-grocery-delivery',
    },
    {
      name: 'Houston',
      url: '/cities/houston-grocery-delivery',
    },
    {
      name: 'Manhattan',
      url: '/cities/manhattan-grocery-delivery',
    },
    {
      name: 'View All',
      url: '/cities',
      showUnderline: true,
    },
  ],
}

const shopSuburbsSection: FooterSection = {
  title: 'Shop Suburbs',
  links: [
    {
      name: 'Arlington',
      url: '/cities/arlington-tx-grocery-delivery',
    },
    {
      name: 'Aurora',
      url: '/cities/aurora-co-grocery-delivery',
    },
    {
      name: 'Warren',
      url: '/cities/warren-mi-grocery-delivery',
    },
    {
      name: 'Upper Darby',
      url: '/cities/upper-darby-pa-grocery-delivery',
    },
    {
      name: 'Long Beach',
      url: '/cities/long-beach-grocery-delivery',
    },
    {
      name: 'View All',
      url: '/cities',
      showUnderline: true,
    },
  ],
}

const shopHealthTransparency: FooterSection = {
  title: 'Healthplan Transparency',
  links: [
    {
      url: 'https://healthy.kaiserpermanente.org/front-door/machine-readable',
      name: 'Kaiser Permanente',
      external: true,
    },
    {
      url: 'https://www.bcbsal.org/web/tcr',
      name: 'BCBS of Alabama',
      external: true,
    },
  ],
}

export const shopperSections: FooterSection[] = [
  shopAndEarnSection,
  shopCitiesSection,
  shopSuburbsSection,
  shopHealthTransparency,
]
